<template>
  <el-drawer title="工单详情" :visible.sync="drawer" size='800px' :direction="direction">
    <div class="content">
      <div class="order">
        <p class="title">工单信息</p>
        <p class="info">编号： {{ order.id }}</p>
        <p class="info">名称： {{ order.name }}</p>
        <p class="info">基地站： {{ order.workBaseName }}</p>
        <p class="info">类型： {{ typeObj[order.type] }}</p>
        <p class="info">开始时间： {{ order.startTime }}</p>
        <p class="info">结束时间： {{ order.endTime }}</p>
        <p class="info">现场负责人： {{ order.mainExecutorName }}</p>
        <p class="info">
          协作人员：
          <span v-for="(staff, index) in order.assistantList" :key="staff.userId">{{staff.userName}}
            <span v-if="index < (order.assistantList.length - 1)">、</span>
          </span>
        </p>
        <p class="info tree-content">
          关联设备：
          <el-tree :data="treeData" show-checkbox default-expand-all node-key="measureId" ref="tree" highlight-current :props="defaultProps">
          </el-tree>
        </p>
        <p class="info">状态： {{ statusObj[order.status] }}</p>
        <!-- <p class="info">描述： {{ order.describe }}</p> -->
        <p class="info">附件：
          <el-link type="primary" v-for="item in attachList" :key="item.uploaderId" @click="handleDownloadFile(item)" title="点击下载">
            {{ item.fileName }}
          </el-link>
        </p>
        <!-- 关联计划基本信息 -->
        <p class="title">关联计划基本信息</p>
        <p class="info">名称： {{ planInfo.name }}</p>
        <p class="info">类型： {{ typeObj[planInfo.type] }}</p>
        <p class="info">计划开始时间： {{ $moment(planInfo.startTime).format('YYYY-MM-DD') }}</p>
        <p class="info">计划结束时间： {{ $moment(planInfo.endTime).format('YYYY-MM-DD') }}</p>
        <p class="info">创建人： {{ planInfo.creatorNickname }}</p>
        <p class="info">状态： {{ planStatusObj[planInfo.status] }}</p>
        <p class="info">描述： {{ planInfo.describe }}</p>
      </div>
      <div class="time-line">
        <p class="title">工单流程</p>
        <el-timeline>
          <el-timeline-item v-for="(item, index) in timeList" :key="index" :timestamp="item.time" type='primary'>
            <el-card shadow="hover" :body-style="{ padding: '0' }">
              <p class="info">操作人：{{ item.operatorUserNickname }}</p>
              <p class="info">状态： {{ statusObj[item.state] }}</p>
              <p class="info" v-if="item.remark != null">备注： {{ item.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { downloadFileByBase64Data, getFileByBase64Data } from '@common/utils/file.js'
import tree from '@/utils/tree'
export default {
  name: "detail",
  props: {
    statusList: Array,
    typeList: Array,
    planStatusList: Array,
  },
  data () {
    return {
      drawer: false,
      direction: "rtl",
      planInfo: {},
      order: {},
      statusObj: {},
      planStatusObj: {},
      typeObj: {},
      timeList: [],
      attachList: [],
      defaultProps: {
        label: 'measureName',
        children: 'children',
        disabled: this.disabledFn
      }
    };
  },
  methods: {
    disabledFn () {
      return true
    },
    async init (row) {
      this.drawer = true
      this.treeData = []
      this.order = Object.assign({}, row)
      console.log(this.order)
      this.statusList.forEach((item) => {
        this.statusObj[item.value] = item.label
      });
      this.typeList.forEach((item) => {
        this.typeObj[item.value] = item.label
      });
      this.planStatusList.forEach((item) => {
        this.planStatusObj[item.value] = item.label
      })
      const workOrderId = this.order.workOrderId ? this.order.workOrderId : this.order.id
      this.$api.electricOperations.listElectricOperationsPlansByWorkOrder([workOrderId]).then((res) => {
        if (res.success) {
          console.log(res)
          this.planInfo = res.data[0].plan
        }
      })
      this.$api.electricOperations.listElectricOperationsWorkOrderStateChangingHistory(workOrderId).then((res) => {
        if (res.success) {
          console.log(res)
          this.timeList = res.data.reverse()
        }
      })
      const res = await this.$api.electricOperations.getMOViewTreeNodes(this.order.clientCompanyId)
      if (res.success) {
        const list = res.data.map((item) => {
          return {
            ...item,
            disabled: true
          }
        })
        this.treeData = tree.creatMeasureTreeJson(list, 0)
        this.$nextTick(() => {
          const measureId = this.order.measureList.map((item) => {
            return item.measureId
          })
          this.$refs.tree.setCheckedKeys(measureId)
        })
      }
      // 获取附件
      const fileRequestList = this.order.attachList.length > 0 ? this.order.attachList.map((item) => {
        return this.$api.file.pullCompanySmallFile(item.fileResourceId)
      }) : []
      if (fileRequestList.length > 0) {
        Promise.all(fileRequestList).then((res) => {
          if (res[0].success) {
            console.log(res)
            this.attachList = res.map((item) => {
              return item.data
            })
          }
        })
      }
    },
    handleDownloadFile (file) {
      downloadFileByBase64Data(file.fileName, file.data, file.fileType)
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  display: flex;
  overflow: auto;
  box-sizing: border-box;
}
.order {
  height: calc(100% - 16px);
  width: 400px;
  // overflow: auto;
  margin: 0 0 16px 0;
  padding: 16px;
  box-sizing: border-box;
}

.title {
  padding: 4px 16px;
  background-color: #409eff;
  font-size: 16px;
  text-align: left;
  // border-left: 3px solid #409eff;
  color: #fff;
}

.info {
  margin: 0;
  text-align: left;
  padding: 0 16px 0 16px;
  font-size: 14px;
  color: #333;
  width: 100%;
  white-space: normal;
  word-break: break-all;
  line-height: 36px;
  box-sizing: border-box;
  // overflow: hidden;
  // text-overflow: ellipsis;
}

.time-line {
  padding: 16px 32px 0 16px;
  flex: 1;
  height: fit-content;
  overflow: auto;
  // border: 1px solid #333;
  box-sizing: border-box;
  .title {
    margin-bottom: 16px;
  }
  .info {
    margin: 0;
    line-height: 36px;
  }
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409eff;
    .el-checkbox__inner {
      background-color: #409eff;
      border-color: #409eff;
      &::after {
        border-color: #fff;
      }
    }
  }
}
</style>
